import type { FormInputType } from '@/components/UI/Form/types'

export const BAN_USER_CHECKBOX_VALUE = 'ban-user'

export default function getFeedbackFormInputs({
  showLinkInput = false,
  showBanUserInput = false,
}: {
  showLinkInput?: boolean
  showBanUserInput?: boolean
}): FormInputType[] {
  const feedbackInputs: FormInputType[] = [
    {
      label: `Please ${showLinkInput ? 'describe' : 'elaborate on'} your concern`,
      sublabel: `Please provide as much detail as possible about what happened, and make sure to provide the name(s) of the individual(s) you're reporting.`,
      type: 'textarea',
      name: 'description',
      initialValue: '',
      required: true,
      minLength: 10,
      size: 6,
    },
  ]
  if (showLinkInput) {
    feedbackInputs.push({
      label: 'Link to issue, if applicable',
      sublabel:
        'If your issue is related to a specific page on the site or session, please link to it here.',
      type: 'text',
      name: 'link',
      initialValue: '',
      size: 6,
    })
  }
  if (showBanUserInput) {
    feedbackInputs.push({
      label: "Temporarily suspend user's account?",
      sublabel:
        'If this user has showed malicious intent to disrupt learning or put members of the community in danger, please click the checkbox below to freeze their account until our safety team can review their case.',
      name: 'banUser',
      type: 'multi-checkbox',
      options: [
        {
          value: BAN_USER_CHECKBOX_VALUE,
          label: `Yes, suspend this user's account. I am aware this should be used only in extreme circumstances.`,
        },
      ],
      required: false,
      size: 6,
    })
  }
  return feedbackInputs
}
